export default Object.freeze({
  ORDERS: 'stores-orders',
});
